// src/components/Footer.js
import React from 'react';

const Footer = () => (
    <footer className="footer">
        <p>&copy; 2024 Microchip Central. All rights reserved.</p>
    </footer>
);

export default Footer;
